var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6204 34.4717L12.7227 16.4429L10.4431 17.2729L19.3409 35.3017L21.6204 34.4717Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7689 35.2915L42.6663 17.2634L40.3867 16.4334L31.4893 34.4614L33.7689 35.2915Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81934 20.466C13.6901 20.466 17.6387 15.8845 17.6387 10.233C17.6387 4.58147 13.6901 0 8.81934 0C3.94855 0 0 4.58147 0 10.233C0 15.8845 3.94855 20.466 8.81934 20.466Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5079 8.15015H16.7104V10.2768H39.5079V8.15015Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3046 20.466C49.1758 20.466 53.1246 15.8845 53.1246 10.233C53.1246 4.58147 49.1758 0 44.3046 0C39.4335 0 35.4846 4.58147 35.4846 10.233C35.4846 15.8845 39.4335 20.466 44.3046 20.466Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5622 49.3523C31.4333 49.3523 35.3822 44.7697 35.3822 39.1168C35.3822 33.4639 31.4333 28.8813 26.5622 28.8813C21.691 28.8813 17.7422 33.4639 17.7422 39.1168C17.7422 44.7697 21.691 49.3523 26.5622 49.3523Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthLogo);
export default __webpack_public_path__ + "static/media/healthLogo.a57e469dad8d5d538ec2409de2a7c4ea.svg";
export { ForwardRef as ReactComponent };